// extracted by mini-css-extract-plugin
module.exports = {"description":"MenuItem__description___2IUlE","calories":"MenuItem__calories___24U7d colors__text-light___iqa9K","image":"MenuItem__image___103O8"};